'use client';

import { theme } from '@epos/ui/theme';
import { CssBaseline } from '@mui/material';
import { Experimental_CssVarsProvider as CssVarThemeProvider } from '@mui/material';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';

const ThemeRegistry: React.FC<ComponentWithChildren> = ({ children }) => {
  return (
    <AppRouterCacheProvider options={{ key: 'epos' }}>
      <CssVarThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        {children}
      </CssVarThemeProvider>
    </AppRouterCacheProvider>
  );
};

export default ThemeRegistry;
